import React from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import { useAppDispatch, useAppSelector } from "app/store";
import {
  closeModalError,
  selectStateModalError,
} from "app/store/trackingApp/modalErrorSlice";
import ErrorSvg from "../ErrorSvg";
import { Main, Overlay, Btn } from "./styles";

const ModalError: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectStateModalError);
  const { text, title, btnLabel } = state.content;

  const _handleClose = () => dispatch(closeModalError());

  return (
    <>
      {state.open && (
        <>
          <Main className="fixed bg-white flex justify-center flex-wrap z-20 p-7 gap-4">
            <CloseIcon
              onClick={_handleClose}
              className="absolute top-2 right-2 text-xl cursor-pointer"
              style={{ color: "#000" }}
            />
            <div
              className="bg-gray-50 flex justify-center"
              style={{ width: 436, borderRadius: "8px" }}
            >
              <ErrorSvg />
            </div>
            <p className="w-full text-center font-bold text-red-800 mt-4 flex items-center justify-center gap-2 flex-wrap">
              <CancelIcon />
              <span className="text-2xl leading-none">{title}</span>
            </p>
            <p
              className={`px-8 w-full ${
                text.includes("\n") ? "whitespace-pre-wrap contents" : "text-center"
              } `}
            >
              {text}
            </p>
            <div className="w-full justify-center flex">
              <Btn
                onClick={_handleClose}
                className="text-red-800 border-red-800 border-solid border"
                label={btnLabel}
              >
                {btnLabel}
              </Btn>
            </div>
          </Main>
          <Overlay
            className="fixed w-full h-full z-10 top-0 left-0"
            onClick={_handleClose}
          />
        </>
      )}
    </>
  );
};

export default ModalError;
